import * as ReducerActions from "../actions/pdfLibrary";

const initialState = {
    library: {
        name: "library",
        uuid: 0
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ReducerActions.UPDATE_LIBRARY:
            return { ...state, library: action.value };
        default:
            return state;
    }
};

export default reducer;
